import React from 'react';
// Using NavLink is better for automatically handling the 'active' class
import { NavLink } from 'react-router-dom';

import '../../styles/employee/employee-sidebar.css';
import logo from '../../assets/images/Logo.png';
import dashboardIcon from '../../assets/images/DashboardIcon.png';
import vector from '../../assets/images/Vector.png';
import assignedCandidateList from '../../assets/images/AssignedCandidateList.png';

const Sidebar = () => {
  return (
    <aside className="emp-app-sidebar">
  

      <nav className="emp-sidebar-nav">
        <ul>
          <li>
            <NavLink to="/employee/dashboard" className="emp-nav-item">
              <span className="emp-nav-icon">
                <img src={dashboardIcon} alt="Dashboard Icon" className="emp-nav-icon-logo" />
              </span>
              Dashboard
            </NavLink>
          </li>
          
          {/* A styled list item serves as a semantic divider */}
          <li className="emp-sidebar-divider" />

          <li>
            <NavLink to="/employee/profile" className="emp-nav-item">
              <span className="emp-nav-icon">
                <img src={vector} alt="Profile Icon" className="emp-nav-icon-logo" />
              </span>
              Profile
            </NavLink>
          </li>

          <li className="emp-sidebar-divider" />
          
          <li>
            <NavLink to="/employee/assignedCandidates" className="emp-nav-item">
              <span className="emp-nav-icon">
                <img src={assignedCandidateList} alt="Candidates Icon" className="emp-nav-icon-logo" />
              </span>
              Assigned Candidates
            </NavLink>
          </li>
        </ul>
      </nav>
    </aside>
  );
};

export default Sidebar;